'use strict';

angular.module('Directives').directive('ngFlot', function($timeout) {
    return {
        'restrict': 'A',
        'scope': {
            options: '=ngFlot'
        },
        'link': function linkingFunction($scope, element, attr) {
            element.plot($scope.options['data'], $scope.options['options']);
        },
        'controller': function($scope) {

        }
    }
});


// WEBPACK FOOTER //
// ./js/directives/flot.js